import { 
  LOAD_INTERPRETATION_FILE_DATA_IN_PROGRESS,
  LOAD_INTERPRETATION_FILE_DATA_SUCCESS,
  LOAD_INTERPRETATION_FILE_DATA_FAILURE,
  OPEN_INTERPRETATION_FILE_DIALOG,
  CLOSE_INTERPRETATION_FILE_DIALOG,
  INTERPRETATION_FILE_OPERATION_COMPLETED
} from "./actions";

const initialState = { isLoading: false, interpretationData: [] };

export const interpretationFileData= (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    
    case LOAD_INTERPRETATION_FILE_DATA_SUCCESS: {
      const { data } = payload;
      return {
        ...state,
        isLoading: false,
        interpretationData: data,
      };
    }
    case LOAD_INTERPRETATION_FILE_DATA_IN_PROGRESS:
      return {
        ...state,
        isLoading: true,
      };
    case LOAD_INTERPRETATION_FILE_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
      case INTERPRETATION_FILE_OPERATION_COMPLETED:
        return {
            ...state,
            isLoading: false,
        }; 

        case OPEN_INTERPRETATION_FILE_DIALOG:
        return {
            ...state,
            isInterpretationFileDialogOpen: true,
        }; 

        case CLOSE_INTERPRETATION_FILE_DIALOG:
        return {
          ...state,
          isInterpretationFileDialogOpen: false,
        }; 
    default:
      return state;
  }
};
